import React from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { tokens } from '../../../../public/tokens';
import { CHART_COLORS, CHART_MARGIN, ChartBody, ChartFrame, ChartTitle } from '../../../library/Chart';
import { LegendText, PIE_ANGLES } from './Charts.styles';

/**
 * Subject pie on the class report; all-zero data gets equal slices so the pie still draws.
 * @param {{ label: string, y: number }[]} data One row per subject
 */
export default function SubjectChart({ data }) {
    const total = data.reduce((runningTotal, subject) => runningTotal + Number(subject.y), 0);
    const slices = data.map((subject) => ({ ...subject, sliceSize: total === 0 ? 1 : Number(subject.y) }));

    return (
        <ChartFrame $height={300}>
            <ChartTitle>Subject</ChartTitle>
            <ChartBody>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart margin={CHART_MARGIN}>
                        <Pie
                            data={slices}
                            dataKey="sliceSize"
                            nameKey="label"
                            outerRadius="100%"
                            stroke={tokens.colors.neutral.white}
                            strokeWidth={1}
                            {...PIE_ANGLES}
                        >
                            {slices.map((slice, index) => (
                                <Cell key={slice.label} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip formatter={(sliceSize, subject, sliceEntry) => sliceEntry.payload.y} />
                        <Legend
                            layout="vertical"
                            align="right"
                            verticalAlign="middle"
                            iconType="circle"
                            iconSize={8}
                            itemSorter={null}
                            formatter={(subject) => <LegendText>{subject}</LegendText>}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </ChartBody>
        </ChartFrame>
    );
}
